// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7f23b018","239":"22a2e508","453":"5ffc6767","667":"c8ff5eb1"}[chunkId] + ".chunk.js";
};